<template>
	<div>
		<v-alert
			@input="() => (isError = false)"
			v-if="isError"
			color="red"
			dismissible
			type="error"
			text
			close-icon="mdi-close"
			class="subtitle-1 py-2 px-4 mt-2 mx-8"
		>
			Nie masz uprawnień do edytowania zadań: {{ errorTasks }}.
		</v-alert>
		<div>
			<v-card-text>
				<div v-if="tasks.length && !loading">
					<div class="d-flex flex-row align-items-center">
						<div class="mr-2">
							<v-tooltip top>
								<template v-slot:activator="{ on }">
									<v-btn
										v-on="on"
										class="ma-0"
										color="lighten-1"
										@click="changeAllTasks()"
										icon
									>
										<v-icon v-if="!checkboxAll" color="accent" sm>mdi-checkbox-blank-outline</v-icon>
										<v-icon v-else color="accent">mdi-checkbox-marked</v-icon>
									</v-btn>
								</template>
								<template v-if="!checkboxAll">Zaznacz wszystkie</template>
								<template v-else>Odznacz wszystkie</template>
							</v-tooltip>
						</div>

						<template v-if="view.name !== 'deleted'">
							<div v-if="view.name !== 'completed' && view.name !== 'commissioned'" class="mr-2">
								<multi-task-item
									@multitaskClick="multiFinish()"

									:tooltipName="
										$vuetify.lang.t(
											'$vuetify.views.tasks.listOfTasks.tooltip.complete'
										)
									"
									backgroundColor="#def2e9"
									iconColor="#1ba769"
									:active="!checkedTasks.length"
								>
									<template> $tick </template>
								</multi-task-item>
							</div>

							<div v-if="view.name === 'completed'" class="mr-2">
								<multi-task-item
									@multitaskClick="multiUnfinish()"
									tooltipName="Nieukończone"
									backgroundColor="#def2e9"
									iconColor="#1ba769"

									:active="!checkedTasks.length"
								>
									<template> mdi-arrow-left-top </template>
								</multi-task-item>
							</div>
							<div v-if="view.name !== 'received' && view.name !== 'commissioned'" class="mr-2">
								<multi-task-item
									@multitaskClick="multiDelete()"
									:tooltipName="
										$vuetify.lang.t(
											'$vuetify.views.tasks.listOfTasks.tooltip.delete'
										)
									"
									backgroundColor="#ffe0e1"
									iconColor="#de1c22"
									:active="!checkedTasks.length"
								>
									<template>$delete</template>
								</multi-task-item>
							</div>

							<v-menu
								v-if="
									view.name !== 'received' &&
									view.name !== 'completed'
								"
								bottom
								offset-y
								:close-on-content-click="false"
							>
								<template v-slot:activator="{ on, attrs }">
									<div class="mr-2">
										<v-btn
											v-bind="attrs"
											v-on="on"
											color="transparent"
											icon
											:disabled="!checkedTasks.length"
										>
											<multi-task-item
												:tooltipName="
													$vuetify.lang.t(
														'$vuetify.views.tasks.listOfTasks.tooltip.transfer'
													)
												"
												v-bind="attrs"
												v-on="on"
												backgroundColor="#fdf6ef"
												iconColor="#e5a44d"
											>
												<template> $add-person </template>
											</multi-task-item>
										</v-btn>
									</div>
								</template>
								<user-list
									@selectUser="multiSelectUser($event)"
								/>
							</v-menu>

							<v-menu
								v-if="view.name !== 'commissioned'"
								bottom
								offset-y
								:close-on-content-click="false"
								class="mb-0"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										color="transparent"
										icon
										class="mr-2"
										:disabled="!checkedTasks.length"
									>
										<multi-task-item
											:tooltipName="
												$vuetify.lang.t(
													'$vuetify.views.tasks.listOfTasks.tooltip.list'
												)
											"
											backgroundColor="#fdf6ef"
											iconColor="#e5a44d"
										>
											<template> $add-file </template>
										</multi-task-item>
									</v-btn>
								</template>
								<v-list class="pa-4 text-center">
									<span
										class="subtitle-2 font-weight-bold text-dark-grey"
									>
										{{
											$vuetify.lang.t(
												"$vuetify.views.tasks.listOfTasks.tooltip.list"
											)
										}}
									</span>

									<v-divider class="my-2" />

									<v-list-item
										@click="multiSelectList(list.id)"
										:key="list.id"
										v-for="list in lists"
										class="list-item subtitle-2"
										link
									>
										{{ list.name }}
									</v-list-item>
								</v-list>
							</v-menu>

							<v-menu
								v-if="view.name !== 'received'"
								bottom
								offset-y
								:close-on-content-click="false"
								class="mb-0"
							>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-bind="attrs"
										v-on="on"
										color="transparent"
										icon
										class="mr-2"
										:disabled="!checkedTasks.length"
									>
										<multi-task-item
											:tooltipName="
												$vuetify.lang.t(
													'$vuetify.views.tasks.listOfTasks.tooltip.priority'
												)
											"
											backgroundColor="#fdf6ef"
											iconColor="#e5a44d"
										>
											<template> $set-priority </template>
										</multi-task-item>
									</v-btn>
								</template>
								<v-list class="pa-4 text-center">
									<span
										class="subtitle-2 font-weight-bold text-dark-grey"
									>
										{{
											$vuetify.lang.t(
												"$vuetify.views.tasks.listOfTasks.priority.setPriority"
											)
										}}
									</span>

									<v-divider class="my-4" />

									<v-radio-group
										@change="multiSelectPriority()"
										v-model="priority"
										class="mt-1"
									>
										<v-radio value="null" :ripple="false">
											<template v-slot:label>
												<span>
													{{
														$vuetify.lang.t(
															"$vuetify.views.tasks.listOfTasks.priority.lack"
														)
													}}
												</span>
											</template>
										</v-radio>
										<v-radio value="low" :ripple="false">
											<template v-slot:label>
												<priority class="low-priority">
													{{
														$vuetify.lang.t(
															"$vuetify.views.tasks.listOfTasks.priority.low"
														)
													}}
												</priority>
											</template>
										</v-radio>

										<v-radio value="medium" :ripple="false">
											<template v-slot:label>
												<priority
													class="medium-priority"
												>
													{{
														$vuetify.lang.t(
															"$vuetify.views.tasks.listOfTasks.priority.medium"
														)
													}}
												</priority>
											</template>
										</v-radio>

										<v-radio value="high" :ripple="false">
											<template v-slot:label>
												<priority class="high-priority">
													{{
														$vuetify.lang.t(
															"$vuetify.views.tasks.listOfTasks.priority.hight"
														)
													}}
												</priority>
											</template>
										</v-radio>
									</v-radio-group>
								</v-list>
							</v-menu>

							<date-time-picker
								v-if="view.name !== 'received'"
								@selected="multiSeleceDate($event)"
								:isIcon="true"
								:disabled="!checkedTasks.length"
							>
								<multi-task-item
									:tooltipName="
										$vuetify.lang.t(
											'$vuetify.views.tasks.listOfTasks.tooltip.postpone'
										)
									"
									backgroundColor="#fdf6ef"
									iconColor="#e5a44d"
								>
									<template>$calendar</template>
								</multi-task-item>
							</date-time-picker>

							<v-spacer></v-spacer>
						</template>
						<template v-else>
							<v-btn
								@click="undoDelete()"
								color="grey lighten-1"
								height="32"
								class="mb-2"
								:disabled="!checkedTasks.length"
							>
								{{
									$vuetify.lang.t(
										"$vuetify.views.tasks.listOfTasks.undoDelete"
									)
								}}
							</v-btn>
							<v-spacer></v-spacer>
						</template>

						<v-menu offset-y :nudge-bottom="4" elevation="0">
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									v-bind="attrs"
									v-on="on"
									height="32"
									class="menu-btn select-btn"
									color="background lighten-1"
									:ripple="false"
								>
									{{ selectSorting }}
									<v-icon>mdi-chevron-down </v-icon>
								</v-btn>
							</template>
							<v-list>
								<v-list-item
									v-show="item.name !== selectSorting"
									@click="changeSorting(item)"
									:key="item.name"
									v-for="item in sorting"
									link
									class="list-item subtitle-2"
								>
									{{ item.name }}
								</v-list-item>
							</v-list>
						</v-menu>
					</div>

					<template>
						<v-simple-table :calculate-widths="true" class="font-14 mt-3">
							<template v-slot:default>
								<thead>
									<tr>
										<th class="text-left task__title">
											{{
												$vuetify.lang.t(
													"$vuetify.views.tasks.listOfTasks.taskRow.task"
												)
											}}
										</th>
										<th class="text-left task__title">
											{{
												$vuetify.lang.t(
													"$vuetify.views.tasks.listOfTasks.taskRow.deadline"
												)
											}}
										</th>
										<th class="text-left task__title">
											{{
												$vuetify.lang.t(
													"$vuetify.views.tasks.listOfTasks.taskRow.priority"
												)
											}}
										</th>
										<th class="text-left task__title">
											{{
												$vuetify.lang.t(
													"$vuetify.views.tasks.listOfTasks.taskRow.type"
												)
											}}
										</th>
									</tr>
								</thead>
								<tbody>
									<task-list-item
										@changeTaskCheck="
											changeTaskCheck($event)
										"
										class="rounded"
										:key="task.id + checkedTasks"
										v-for="task in tasks"
										:task="task"
										@openTaskDialog="openTaskDialog(task)"
										:isTaskChecked="
											checkedTasks.filter(
												(t) => t === task.id
											).length > 0
										"
									/>
								</tbody>
							</template>
						</v-simple-table>
					</template>

					<v-pagination
						class="training-nav"
						@input="changePage()"
						@change="changePage()"
						v-model="page"
						color="primary"
						:length="totalPages"
						:total-visible="7"
					>
					</v-pagination>

					<task-edit-dialog
						:key="!selectedTask || selectedTask.id"
						v-if="selectedTask && view.name !== 'deleted'"
						:task="selectedTask"
						@closeDialog="closeTaskDialog()"
						:dialog="dialog"
					/>
				</div>

				<div v-else-if="loading">
					<div class="mb-5"></div>
					<v-skeleton-loader
						:key="index"
						v-for="index in 10"
						type="text"
						class="py-2 px-3"
					></v-skeleton-loader>
				</div>

				<v-card
					flat
					outlined
					class="py-12 d-flex flex-column align-center"
					v-else
				>
					<div class="tick-container">
						<v-icon class="tick-icon pa-3">$big-tick</v-icon>
					</div>
					<div class="bold font-14">
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.listOfTasks.noTask.header"
							)
						}}
					</div>
					<div class="text-grey">
						{{
							$vuetify.lang.t(
								"$vuetify.views.tasks.listOfTasks.noTask.subtitle"
							)
						}}
					</div>
				</v-card>
			</v-card-text>
		</div>
	</div>
</template>

<script>
import TaskListItem from "@/components/tasks/list/TaskListItem";
import TaskEditDialog from "@/components/tasks/dialogs/TaskEditDialog";
import MultiTaskItem from "@/components/tasks/MultiTaskItem";
import UserList from "@/components/tasks/UserList";
import DateTimePicker from "@/components/pickers/DateTimePicker.vue";
import Priority from "@/components/tasks/Priority";

import { mapGetters, mapActions } from "vuex";
import axios from "axios";

import { labelDate } from "@/components/tasks/taskHelpers.js";

export default {
	components: {
		TaskListItem,
		TaskEditDialog,
		MultiTaskItem,
		UserList,
		DateTimePicker,
		Priority,
	},
	data() {
		return {
			isError: false,
			errorTasks: "",
			checkedTasks: [],
			dialog: false,
			checkboxAll: false,
			priority: "",
			page: 1,
			selectedTask: null,
			sorting: [
				{ order: "desc", sortBy: "id", name: "Sortuj od najnowszych" },
				{ order: "asc", sortBy: "id", name: "Sortuj od najstarszych" },
				{
					order: "asc",
					sortBy: "deadline",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.ascDeadline"
					),
				},
				{
					order: "desc",
					sortBy: "deadline",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.descDeadline"
					),
				},
				{
					order: "asc",
					sortBy: "priority",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.ascPriority"
					),
				},
				{
					order: "desc",
					sortBy: "priority",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.descPriority"
					),
				},
				{
					order: "asc",
					sortBy: "title",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.asc"
					),
				},
				{
					order: "desc",
					sortBy: "title",
					name: this.$vuetify.lang.t(
						"$vuetify.views.tasks.listOfTasks.filters.desc"
					),
				},
			],
		};
	},

	computed: {
		...mapGetters({
			tasks: "tasks/tasks",
			lists: "tasks/lists",
			currentPage: "tasks/currentPage",
			totalPages: "tasks/totalPages",
			sortBy: "tasks/sortBy",
			order: "tasks/order",
			loading: "tasks/loading",
			view: "tasks/view",
			tags: "tasks/tags",
		}),

		selectSorting() {
			const a = this.sorting.filter((item) => {
				if (item.order === this.order && item.sortBy === this.sortBy) {
					return item;
				}
			});

			return a[0].name;
		},
	},
	watch: {
		currentPage() {
			this.page = this.currentPage;
			this.changePage();
		},
		view() {
			this.dialog = false;
			this.selectedTask = "";
			this.checkedTasks = [];
			this.checkboxAll = false;
		},
	},
	methods: {
		...mapActions("tasks", ["getTasks"]),
		openTaskDialog(task) {
			this.selectedTask = task;
			this.dialog = true;
		},
		closeTaskDialog() {
			this.dialog = false;
			this.selectedTask = "";
		},
		changePage() {
			this.getTasks({ currentPage: this.page });
		},
		changeSorting(item) {
			this.$store.commit("tasks/setOrder", item.order);
			this.$store.commit("tasks/setSortBy", item.sortBy);
			this.getTasks({ currentPage: 1 });
		},
		changeAllTasks() {
			console.log("SHOULD")
			this.checkedTasks = [];
			this.checkboxAll = !this.checkboxAll;

			if (this.checkboxAll) {
				this.tasks.forEach((task) => {
					this.checkedTasks.push(task.id);
				});
			}

		},
		changeTaskCheck(isTaskChecked) {
			if (isTaskChecked.checked) {
				this.checkedTasks.push(isTaskChecked.id);
			} else {
				const idx = this.checkedTasks.findIndex(
					(taskID) => taskID === isTaskChecked.id
				);

				this.checkedTasks.splice(idx, 1);
			}
		},
		undoDelete() {
			if (this.checkedTasks.length) {
				axios
					.get("tasks/restore/data", {
						params: { tasks_ids: this.checkedTasks },
					})
					.then(() => {
						this.checkedTasks.forEach((id) => {
							const task = this.tasks.find((t) => t.id === id);
							task.deadline &&
								this.incFromTermsVievs(task.deadline);

							if (task.task_list_id) {
								const inx = this.lists.findIndex(
									(list) =>
										list.id ===
										this.tasks.find(
											(task) => task.id === id
										).task_list_id
								);

								this.lists[inx] &&
									this.lists[inx].total_tasks &&
									this.lists[inx].total_tasks++;
							}
						});

						this.$store.state.tasks.deletedCount -=
							this.checkedTasks.length;

						this.$store.commit(
							"tasks/deleteTasks",
							this.checkedTasks
						);

						this.$store.state.tasks.allTasksCount[0] =
							this.$store.state.tasks.allTasksCount[0] +
							this.checkedTasks.length;

						this.$store.state.tasks.allTasksCount = Object.assign(
							[],
							this.$store.state.tasks.allTasksCount
						);

						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("RESTORE TASKS ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});
			}
		},
		multiFinish() {
			if (this.checkedTasks.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: this.checkedTasks,
							status: "finished",
						},
					})
					.then(() => {
						this.checkedTasks.forEach((id) => {
							const task = this.tasks.find(
								(task) => task.id === id
							);
							task.deadline &&
								this.decFromTermsVievs(task.deadline);

							task.creator_user &&
								this.$store.state.tasks.recievedTasks--;

							if (task.task_list_id) {
								const inx = this.lists.findIndex(
									(list) =>
										list.id ===
										this.tasks.find(
											(task) => task.id === id
										).task_list_id
								);

								this.lists[inx] &&
									this.lists[inx].total_tasks &&
									this.lists[inx].total_tasks--;
							}
						});

						this.$store.state.tasks.allTasksCount[0] -=
							this.checkedTasks.length;
						this.$store.state.tasks.completedTasksCount +=
							this.checkedTasks.length;
						this.$store.commit(
							"tasks/deleteTasks",
							this.checkedTasks
						);
						this.$store.state.tasks.allTasksCount = Object.assign(
							[],
							this.$store.state.tasks.allTasksCount
						);
						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS STATUS ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});
			}
		},
		multiUnfinish() {
			if (this.checkedTasks.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: this.checkedTasks,
							status: "unfinished",
						},
					})
					.then(() => {
						this.checkedTasks.forEach((id) => {
							const task = this.tasks.find((t) => t.id === id);
							task.deadline &&
								this.incFromTermsVievs(task.deadline);
							task.creator_user &&
								this.$store.state.tasks.recievedTasks++;

							if (task.task_list_id) {
								const inx = this.lists.findIndex(
									(list) =>
										list.id ===
										this.tasks.find(
											(task) => task.id === id
										).task_list_id
								);

								this.lists[inx] &&
									this.lists[inx].total_tasks &&
									this.lists[inx].total_tasks--;
							}
						});

						this.$store.state.tasks.allTasksCount[0] +=
							this.checkedTasks.length;
						this.$store.state.tasks.completedTasksCount -=
							this.checkedTasks.length;
						this.$store.commit(
							"tasks/deleteTasks",
							this.checkedTasks
						);
						this.$store.state.tasks.allTasksCount = Object.assign(
							[],
							this.$store.state.tasks.allTasksCount
						);
						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS STATUS ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});
			}
		},
		multiTaskValidation() {
			let correctID = [];

			this.checkedTasks.forEach((id) => {
				const item = this.$store.state.tasks.tasks.find(
					(task) => task.id === id
				);

				if (item.creator_user_id) {
					this.errorTasks += ` ${item.title}, `;
				} else {
					correctID.push(id);
				}
			});

			this.errorTasks = this.errorTasks.slice(0, -2);

			if (!correctID.length) {
				this.isError = true;
				this.checkedTasks = [];
			}

			return correctID;
		},
		multiSelectUser(userID) {
			this.errorTasks = "";
			const correctID = this.multiTaskValidation();

			if (correctID.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: correctID,
							user_id: userID,
							creator_user_id:
								userID === this.$store.state.auth.user.id
									? null
									: this.$store.state.auth.user.id,
							tags: [],
							task_list_id: null,
						},
					})
					.then(() => {
						if (userID === this.$store.state.auth.user.id) {
							this.$store.state.tasks.commisionedTasks -=
								correctID.length;
							this.$store.state.tasks.allTasksCount[0] +=
								correctID.length;
						} else {
							this.$store.state.tasks.allTasksCount[0] -=
								correctID.length;
							this.$store.state.tasks.commisionedTasks +=
								correctID.length;
						}

						correctID.forEach((id) => {
							const task = this.tasks.find(
								(task) => task.id === id
							);
							const listInx = this.lists.findIndex(
								(list) => list.id === task.task_list_id
							);

							task.taggables.forEach((tag) => {
								const tagInx = this.tags.findIndex(
									(t) => t.id === tag.tag.id
								);
								tagInx &&
									this.tags[tagInx].unfinished_tasks_count--;
							});

							this.$store.state.tasks.lists[listInx] &&
								this.$store.state.tasks.lists[listInx]
									.total_tasks--;

							this.decFromTermsVievs(task.deadline);
						});
						this.$store.state.tasks.lists = Object.assign(
							[],
							this.$store.state.tasks.lists
						);

						this.$store.commit("tasks/deleteTasks", correctID);
						this.$store.state.tasks.allTasksCount = Object.assign(
							[],
							this.$store.state.tasks.allTasksCount
						);

						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS USER ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});
			}

			if (this.errorTasks) {
				this.isError = true;
			}
		},
		multiSelectList(listID) {
			if (this.checkedTasks.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: this.checkedTasks,
							task_list_id: listID,
						},
					})
					.then(() => {
						this.checkedTasks.forEach((id) => {
							const inx = this.lists.findIndex(
								(list) =>
									list.id ===
									this.tasks.find((task) => task.id === id)
										.task_list_id
							);

							this.lists[inx] &&
								this.lists[inx].total_tasks &&
								this.lists[inx].total_tasks--;
						});

						const inx = this.lists.findIndex(
							(list) => list.id === listID
						);

						this.checkedTasks.forEach(() => {
							this.lists[inx] && this.lists[inx].total_tasks++;
						});

						this.$store.state.tasks.lists = Object.assign(
							[],
							this.lists
						);

						if (this.view.name === "list") {
							this.$store.commit(
								"tasks/deleteTasks",
								this.checkedTasks
							);
						}

						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE LIST ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});
			}
		},
		multiSelectPriority() {
			this.errorTasks = "";
			const correctID = this.multiTaskValidation();

			if (correctID && correctID.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: correctID,
							priority: this.priority,
						},
					})
					.then(() => {
						this.$store.state.tasks.tasks.forEach((task, inx) => {
							correctID.forEach((id, inx2) => {
								if (task.id === id) {
									this.$store.state.tasks.tasks[
										inx
									].priority = this.priority;
									correctID.splice(inx2, 1);
								}
							});
						});
						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS USER ERROR", error);
					});

				if (this.errorTasks) {
					this.isError = true;
				}
			}
		},
		decFromTermsVievs(date) {
			const termTags = labelDate(date) || [];
			if (termTags.find((item) => item === "today")) {
				this.$store.state.tasks.allTasksCount[1]--;
			}
			if (termTags.find((item) => item === "tomorrow")) {
				this.$store.state.tasks.allTasksCount[2]--;
			}
			if (termTags.find((item) => item === "thisWeek")) {
				this.$store.state.tasks.allTasksCount[3]--;
			}
		},
		incFromTermsVievs(data) {
			const termTags = labelDate(this.$moment(data).parseZone());

			if (termTags.find((item) => item === "today")) {
				this.$store.state.tasks.allTasksCount[1]++;
			}
			if (termTags.find((item) => item === "tomorrow")) {
				this.$store.state.tasks.allTasksCount[2]++;
			}
			if (termTags.find((item) => item === "thisWeek")) {
				this.$store.state.tasks.allTasksCount[3]++;
			}
		},
		multiSeleceDate(date) {
			this.errorTasks = "";
			const correctID = this.multiTaskValidation();

			if (correctID.length) {
				axios
					.get("tasks-bulk-update", {
						params: {
							tasks_ids: correctID,
							deadline: this.$moment(date)
								.parseZone()
								.format("YYYY-MM-DD HH:mm:ss"),
						},
					})
					.then(() => {
						this.$store.state.tasks.tasks.forEach((task, inx) => {
							correctID.forEach((id, inx2) => {
								if (task.id === id) {
									if (!this.tasks[inx].creator_user_id) {
										this.tasks[inx].deadline &&
											this.decFromTermsVievs(
												this.tasks[inx].deadline
											);

										date && this.incFromTermsVievs(date);

										this.$store.state.tasks.allTasksCount =
											Object.assign(
												[],
												this.$store.state.tasks
													.allTasksCount
											);
									}

									this.$store.state.tasks.tasks[
										inx
									].deadline = this.$moment(date)
										.parseZone()
										.format("YYYY-MM-DD HH:mm:ss");
									correctID.splice(inx2, 1);
								}
							});
						});
						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS DATA ERROR", error);
					});

				if (this.errorTasks) {
					this.isError = true;
				}
			}
		},

		multiDelete() {
			this.errorTasks = "";
			const correctID = this.multiTaskValidation();

			if (correctID.length) {
				axios
					.get("tasks-bulk-delete", {
						params: {
							tasks_ids: correctID,
						},
					})
					.then(() => {
						correctID.forEach((id) => {
							const task = this.tasks.find(
								(task) => task.id === id
							);

							if (task.status === "unfinished") {
								task.deadline &&
									this.decFromTermsVievs(task.deadline);
							}

							if (task.task_list_id) {
								const inx = this.lists.findIndex(
									(list) =>
										list.id ===
										this.tasks.find(
											(task) => task.id === id
										).task_list_id
								);

								this.lists[inx] &&
									this.lists[inx].total_tasks &&
									this.lists[inx].total_tasks--;
							}
						});

						this.$store.state.tasks.allTasksCount[0] -=
							correctID.length;
						this.$store.state.tasks.deletedCount +=
							correctID.length;
						this.$store.commit("tasks/deleteTasks", correctID);
						this.$store.state.tasks.allTasksCount = Object.assign(
							[],
							this.$store.state.tasks.allTasksCount
						);
						this.checkedTasks = [];
					})
					.catch((error) => {
						console.log("CHANGE TASKS USER ERROR", error);
					})
					.finally(() => {
						this.checkIfTasksIsAlmostEmpty();
					});

				if (this.errorTasks) {
					this.isError = true;
				}
			}
		},
		checkIfTasksIsAlmostEmpty() {
			if (this.tasks.length < 5) {
				this.getTasks({ currentPage: 1 });
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.task__title {
	letter-spacing: 0.2px !important;
	font-size: 13px !important;
	color: var(--v-grey-base) !important;
	font-weight: 300;
}
.tick-icon {
	width: 53px;
	height: 52px;
	background-color: var(--v-secondary);
	border-radius: 50%;
}
.list-item {
	min-height: 32px;
}
.v-menu__content.theme--light.menuable__content__active {
	background: var(--v-background-lighten1);
}
</style>
